import { computed, Ref } from "@vue/composition-api";
import { FILE_UPLOADING_FINALLY_PROCESSING } from "@/const";

export default function useUploadingProgress(progress: Ref<number>) {
  const loaded = computed(() => progress.value === 100);
  const loading = computed(() => progress.value > 0 && progress.value < 100);
  const processing = computed(() => progress.value === FILE_UPLOADING_FINALLY_PROCESSING);

  return {
    loaded,
    loading,
    processing,
  };
}
